
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/provider/login",
      function () {
        return require("private-next-pages/provider/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/provider/login"])
      });
    }
  